import { Injectable } from '@angular/core';
import { TokenClaimsService } from './token-claims.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageHeaderService {
  isAdmin = new BehaviorSubject<boolean>(false);
  isSupport = new BehaviorSubject<boolean>(false);
  isAdmin$ = this.isAdmin.asObservable();
  isSupport$ = this.isSupport.asObservable();

  constructor(private claimsSrv: TokenClaimsService) {}

  setRoles() {
    if (this.claimsSrv.isAdmin) {
      this.isAdmin.next(this.claimsSrv.isAdmin);
    }
    if (this.claimsSrv.isSupport) {
      this.isSupport.next(this.claimsSrv.isSupport);
    }
  }
}
